// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c252a708b84ccde2ed08","655":"6800bb2ab589cb948268"}[chunkId] + ".js";
};